export const formatTimeToHMM = (timeInMilliseconds) => {
  let hours = parseInt((timeInMilliseconds / (1000 * 60 * 60)) % 24);
  let minutes = parseInt((timeInMilliseconds / (1000 * 60)) % 60);
  minutes = minutes < 10 ? '0' + minutes : minutes;

  return hours + 'h' + minutes;
};
